import { render } from "./PackageRevenues.vue?vue&type=template&id=c13e9392"
import script from "./PackageRevenues.vue?vue&type=script&lang=js"
export * from "./PackageRevenues.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__